export enum NumberRangeInputType {
  min,
  max
}
